/*
 * <text-image-rows-mobile-carousel> is the mirror image of the theme's
 * <custom-content-slider>: that component only runs Flickity at desktop
 * widths (>= theme.sizes.small) and destroys it below that. This carousel
 * exists purely for mobile (the exterior carousel spanning every row's
 * slides), so the breakpoint check is inverted — Flickity runs only below
 * the "small" breakpoint and is torn down at/above it.
 */
if (!customElements.get('text-image-rows-mobile-carousel')) {
  class TextImageRowsMobileCarousel extends HTMLElement {
    constructor() {
      super();
      this.checkSliderOnResize = () => this.checkSlider();
      this.resizeSliderEvent = () => this.resizeSlider();
      this.flkty = null;
    }

    connectedCallback() {
      this.checkSlider();
      document.addEventListener('theme:resize:width', this.checkSliderOnResize);
      this.addEventListener('theme:slider:resize', this.resizeSliderEvent);
    }

    checkSlider() {
      if (window.innerWidth < window.theme.sizes.small) {
        this.initSlider();
        requestAnimationFrame(() => {
          this.dispatchEvent(new CustomEvent('theme:slider:resize', { bubbles: true }));
        });
        return;
      }
      this.destroySlider();
    }

    initSlider() {
      if (this.flkty !== null) return;
      if (this.querySelectorAll('[data-slide]').length > 1) {
        this.flkty = new window.theme.Flickity(this, {
          prevNextButtons: true,
          adaptiveHeight: true,
          pageDots: true,
          wrapAround: false,
        });
      }
    }

    destroySlider() {
      if (this.flkty !== null) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }

    resizeSlider() {
      if (this.flkty !== null) {
        this.flkty.resize();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:resize:width', this.checkSliderOnResize);
      this.removeEventListener('theme:slider:resize', this.resizeSliderEvent);
    }
  }

  customElements.define('text-image-rows-mobile-carousel', TextImageRowsMobileCarousel);
}
